export default "__VITE_ASSET__CQ9QN8Zx__"